<template>
  <transition name="modal-fade">
    <div v-if="visible" class="announcement-overlay" @click.self="close">
      <div class="announcement-panel">
        <div class="announcement-header">
          <div class="version-tag">v1.6.0 新版本上线 🎉</div>
          <button class="close-btn" @click="close">✕</button>
        </div>
        <div class="announcement-body">
          <h2 class="announcement-title">{{ isAdmin ? '数据统计 + 移动端优化' : '界面升级，体验更流畅' }}</h2>
          <p class="announcement-date">2026年3月</p>

          <!-- 管理员版本 -->
          <ul v-if="isAdmin" class="change-list">
            <li class="change-item feature">
              <span class="change-icon">📊</span>
              <div>
                <strong>数据统计中心</strong>
                <p>管理后台新增「数据统计」Tab，查看总订单数、人气菜品 Top10、月度趋势折线图、分类占比及食材消耗频率，支持本周/本月/近3月/全部筛选</p>
              </div>
            </li>
            <li class="change-item feature">
              <span class="change-icon">📱</span>
              <div>
                <strong>移动端底部导航栏</strong>
                <p>手机访问时顶部导航链接改为底部固定导航栏（首页/订单/管理/我的），操作更顺手</p>
              </div>
            </li>
            <li class="change-item feature">
              <span class="change-icon">⬆️</span>
              <div>
                <strong>弹窗体验优化</strong>
                <p>手机端所有弹窗（下单、消息中心等）改为从底部滑入，符合移动端操作习惯</p>
              </div>
            </li>
          </ul>

          <!-- 普通用户版本 -->
          <ul v-else class="change-list">
            <li class="change-item feature">
              <span class="change-icon">📱</span>
              <div>
                <strong>移动端底部导航栏</strong>
                <p>手机访问时底部新增导航栏，首页、订单、我的一触即达，不用再往上滑找菜单</p>
              </div>
            </li>
            <li class="change-item feature">
              <span class="change-icon">⬆️</span>
              <div>
                <strong>弹窗体验升级</strong>
                <p>手机端点菜弹窗、消息中心改为从底部滑入，操作更顺手流畅</p>
              </div>
            </li>
            <li class="change-item tip">
              <span class="change-icon">💡</span>
              <div>
                <strong>温馨提示</strong>
                <p>菜品列表在手机端改为单列展示，图片和信息更清晰</p>
              </div>
            </li>
          </ul>
        </div>
        <div class="announcement-footer">
          <label class="no-show-label">
            <input type="checkbox" v-model="dontShowAgain" />
            不再提示此版本公告
          </label>
          <button class="btn-got-it" @click="close">知道了 👌</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'

const SEEN_KEY = 'ff_announcement_v1.6.0'

export default {
  name: 'UpdateAnnouncement',
  data() {
    return {
      visible: false,
      dontShowAgain: false
    }
  },
  computed: {
    ...mapGetters('auth', ['isAdmin', 'isSuperAdmin'])
  },
  mounted() {
    if (!localStorage.getItem(SEEN_KEY)) {
      this.visible = true
    }
  },
  methods: {
    close() {
      if (this.dontShowAgain) {
        localStorage.setItem(SEEN_KEY, '1')
      }
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.announcement-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  @include flex-center;
  padding: $spacing-base;
  backdrop-filter: blur(6px);
}

.announcement-panel {
  background: $color-bg-card;
  border-radius: $radius-xl;
  width: 100%;
  max-width: 520px;
  max-height: 88vh;
  @include flex-col;
  overflow: hidden;
  box-shadow: $shadow-lg;
  animation: slideUp 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.announcement-header {
  @include flex-between;
  padding: $spacing-md $spacing-lg;
  background: linear-gradient(135deg, $color-primary 0%, darken($color-primary, 10%) 100%);
}

.version-tag {
  font-size: $font-size-md;
  font-weight: 700;
  color: #fff;
}

.close-btn {
  @include btn-base;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  font-size: $font-size-sm;
  &:hover { background: rgba(255, 255, 255, 0.35); }
}

.announcement-body {
  flex: 1;
  overflow-y: auto;
  padding: $spacing-lg;
}

.announcement-title {
  font-size: $font-size-lg;
  font-weight: 700;
  color: $color-text-primary;
  margin-bottom: 4px;
}

.announcement-date {
  font-size: $font-size-xs;
  color: $color-text-muted;
  margin-bottom: $spacing-md;
}

.change-list {
  list-style: none;
  @include flex-col;
  gap: $spacing-sm;
}

.change-item {
  display: flex;
  gap: $spacing-md;
  align-items: flex-start;
  padding: $spacing-sm $spacing-md;
  border-radius: $radius-md;

  &.feature {
    background: rgba($color-primary, 0.05);
  }
  &.tip {
    background: rgba(#f59e0b, 0.07);
  }

  strong {
    display: block;
    font-size: $font-size-sm;
    font-weight: 700;
    color: $color-text-primary;
    margin-bottom: 2px;
  }

  p {
    font-size: $font-size-xs;
    color: $color-text-secondary;
    line-height: 1.5;
    margin: 0;
  }
}

.change-icon {
  font-size: 20px;
  flex-shrink: 0;
  margin-top: 1px;
}

.announcement-footer {
  @include flex-between;
  padding: $spacing-md $spacing-lg;
  border-top: 1px solid $color-border-light;
  gap: $spacing-sm;
  flex-wrap: wrap;
}

.no-show-label {
  display: flex;
  align-items: center;
  gap: $spacing-xs;
  font-size: $font-size-xs;
  color: $color-text-muted;
  cursor: pointer;

  input[type="checkbox"] {
    cursor: pointer;
  }
}

.btn-got-it {
  @include btn-base;
  padding: $spacing-sm $spacing-lg;
  background: $color-primary;
  color: #fff;
  border-radius: $radius-md;
  font-weight: 700;
  font-size: $font-size-sm;
  &:hover { opacity: 0.85; }
}

.modal-fade-enter-active, .modal-fade-leave-active { transition: opacity 0.3s ease; }
.modal-fade-enter, .modal-fade-leave-to { opacity: 0; }
</style>
